import { SET_PRODUCT_CATALOG_STATE } from '../types'

export const initialState = {
  search: '',
  sortBy: '',
  minPrice: '0',
  maxPrice: '2000',
  page: 1,
  tag: false,
  categories: [],
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_PRODUCT_CATALOG_STATE:
      return {
        ...state,
        search: action.value.search,
        sortBy: action.value.sortBy,
        minPrice: action.value.minPrice,
        maxPrice: action.value.maxPrice,
        page: action.value.page,
        tag: action.value.tag,
        categories: action.value.categories,
      }
    default:
      return state
  }
}

export default reducer
